const TURNOS_ROUTE_GROUP = [
	'/inicio/programar-turnos',
	'/inicio/turnos-presenciales',
	'/inicio/gestionar-turnos'
]

const ROUTE_GROUPS = {
	'/inicio/programar-turnos': TURNOS_ROUTE_GROUP,
	'/inicio/turnos-presenciales': TURNOS_ROUTE_GROUP,
	'/inicio/gestionar-turnos': TURNOS_ROUTE_GROUP
}

const matchesRoutePrefix = (pathname, route) =>
	pathname === route || pathname.startsWith(`${route}/`)

export const matchesNavigationPath = (pathname, route, relatedRoutes = []) => {
	if (!pathname || !route) return false
	if (route === '/inicio') return pathname === route

	const groupedRoutes = ROUTE_GROUPS[route] || [route]
	const candidateRoutes = [...new Set([...groupedRoutes, ...relatedRoutes])]

	return candidateRoutes.some(candidateRoute => matchesRoutePrefix(pathname, candidateRoute))
}